import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { Tooltip } from '@splashthat/doppler';

const TooltipZIndex = createGlobalStyle`
    [data-radix-popper-content-wrapper] {
        z-index: 90001 !important;
    }
`;

export const TooltipWithinSuiPopovers = (props) => (
    <>
        <TooltipZIndex />
        <Tooltip {...props} />
    </>
);
